<mad-alert
  type="success"
  message="Success! Your subscription payment has been processed."
  size="small"
  (close)="onCloseAlert()"
  (action)="onActionAlert()"
>
</mad-alert>

<mad-alert
  type="info"
  message="You can customize your host."
  size="medium"
  actionText="Action"
  (close)="onCloseAlert()"
  (action)="onActionAlert()"
>
</mad-alert>

<mad-alert
  type="warning"
  message="This feature is still under development."
  size="large"
  actionText="Action"
  (close)="onCloseAlert()"
  (action)="onActionAlert()"
>
</mad-alert>

<mad-alert
  type="error"
  message="Your license is about to expire."
  actionText="Action"
  [closeable]="false"
  (close)="onCloseAlert()"
  (action)="onActionAlert()"
>
</mad-alert>
